export const normalizeUrl = (url: string) => {
  return url.includes('http') ? url.trim() : `https://${url.trim()}`
}
